import { ReactNode, VFC } from 'react';
import Theme from '@adsk/alloy-react-theme';
import Tooltip from '@adsk/alloy-react-tooltip';
import styled from 'styled-components';
import { BaseRfi } from '../../sdk';
import { useMultipleLocationsDisplay } from '../../hooks/useMultipleLocationsDisplay';
import { T } from '../../helpers';
import { InlineLoader, LoaderStyle } from '../InlineLoader';

const { DISPLAY_VARIANTS } = useMultipleLocationsDisplay;

const TOOLTIP_STYLE = { borderRadius: '4px' };
const TOOLTIP_TARGET_PROPS = { style: { width: '100%' } };

export type LocationCellProps = {
  cellData: BaseRfi['locations'];
};

const TooltipWrapper = styled.div`
  > div {
    ${{
      color: Theme.colors.white,
      ...Theme.typography.bodySmall,
      ...DISPLAY_VARIANTS.INLINE,
    }}
  }
`;

export const LocationCell: VFC<LocationCellProps> = ({ cellData: locationIds }) => {
  const { isLoading, locationNamesNodes } = useMultipleLocationsDisplay({
    locationIds,
  });

  const namesCount = locationNamesNodes.length;
  const tooltipContent: ReactNode = namesCount ? (
    <TooltipWrapper>{locationNamesNodes}</TooltipWrapper>
  ) : null;
  const isMultipleLocations = locationNamesNodes.length > 1;

  const cellContent: ReactNode = isMultipleLocations ? (
    <span>{T.translate('tableCells.locations', { count: namesCount })}</span>
  ) : (
    locationNamesNodes[0] || '-'
  );

  const getTargetProps = () => (isMultipleLocations ? {} : TOOLTIP_TARGET_PROPS);

  return (
    <Tooltip
      content={tooltipContent}
      placement={Tooltip.PLACEMENTS.TOP}
      style={TOOLTIP_STYLE}
      getTargetProps={getTargetProps}
    >
      {isLoading ? <InlineLoader loaderStyle={LoaderStyle.Text} /> : cellContent}
    </Tooltip>
  );
};
